import React from 'react'
import GroupBatchPage from './GroupBatchPage'

const GroupBatchContainer = () => {
    return (
        <div className='GroupBatchContainer'>
            <GroupBatchPage />
        </div>
    )
}

export default GroupBatchContainer